<template>
    <div class="field">
        <label :for="name" class="sr-only" v-text="label"></label>
        <div class="control">
            <textarea :class="{ 'is-danger': errors.hasError( name ) }" :value="value" @keydown="clearErrors" @input="handleInput" :placeholder="label"
                      :name="name" :id="name" cols="30" rows="10" class="textarea"></textarea>
        </div>
        <p v-if="errors.hasError( name )" class="help is-danger" v-t="(this.errors.get( name ))"></p>
    </div>
</template>
<script>
    export default {
        props: ['value', 'label', 'name', 'errors'],
        methods: {
            handleInput(e) {
                this.$emit('input', e.target.value)
            },
            clearErrors() {
                this.errors.clear( this.name )
            }
        }
    }
</script>